import {SignInForm} from 'containers/SignInForm/SignInForm';
import {FC} from 'react';

import {Modal} from 'components/Modal/Modal';

import styles from './ModalSignInForm.module.css';

type Props = {
    visible: boolean;
    onClose: () => void;
    onSignInSuccess: () => void;
};
export const ModalSignInForm: FC<Props> = ({
    visible,
    onClose,
    onSignInSuccess,
}) => {
    return (
        <Modal
            visible={visible}
            onClose={onClose}
            className={styles.authModal}
            closeClassName={styles.closeModal}
        >
            <SignInForm
                className={styles.sigInForm}
                onSignInSuccess={onSignInSuccess}
            />
        </Modal>
    );
};
